import React, { useState, useEffect } from "react";
import { AiOutlineLoading } from "react-icons/ai";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

function Processing({message}) {
  const [isfirstSpinner, setIsfirstSpinner] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsfirstSpinner(!isfirstSpinner);
    }, 3000);
  }, [isfirstSpinner]);

  return (
    <div className="text-blue-600 font-medium flex items-center">
      {isfirstSpinner ? (
        <AiOutlineLoading className="mr-2 text-2xl font-bold animate-spin"></AiOutlineLoading>
      ) : (
        <AiOutlineLoading3Quarters className="mr-2 text-2xl font-bold animate-spin"></AiOutlineLoading3Quarters>
      )}

      <p>{message}</p>
    </div>
  );
}

export default Processing;
